/**
 * 导入标准化接口
 *
 * 接口文档地址：https://bailongma.yuque.com/yycxdoc/uuto9q/pfz7gqxnugobcc1m#epgbw
 */
import request from '@/utils/request'
/** 获取导入任务进度 */
export function fetchImportTaskProgress(data = {}) {
  return request({
    url: '/admin/v1/opsx/batchimport/progressBar',
    method: 'post',
    data,
  })
}

/** 获取导入记录列表 */
export function fetchImportHistory(data = {}) {
  return request({
    url: '/admin/v1/opsx/batchimport/historyRecord',
    method: 'post',
    data,
  })
}

/** 拉取导入结果下载地址 */
export function fetchImportResultUrl(data = {}) {
  return request({
    url: '/admin/v1/opsx/batchimport/exportBatchImportTask',
    method: 'post',
    data,
  })
}

/** 拉取导入模版地址 */
export function fetchImportTemplateUrl(data = {}) {
  return request({
    url: '/admin/v1/opsx/batchimport/queryTemplateUrl',
    method: 'post',
    data,
  })
}
